import { render, staticRenderFns } from "./Entrance.vue?vue&type=template&id=1ee83870&scoped=true&"
import script from "./Entrance.vue?vue&type=script&lang=ts&"
export * from "./Entrance.vue?vue&type=script&lang=ts&"
import style0 from "./Entrance.vue?vue&type=style&index=0&id=1ee83870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee83870",
  null
  
)

export default component.exports